<template>
	<div
		v-bind="listGroupProps"
		class="app-favorite-group-item"
	>
		<ao-icon
			iconName="dragNDrop"
			class="draggable-handler text-textSecondary"
		/>
		<v-list-item
			class="rounded px-4"
			density="compact"
			height="32"
			max-height="32"
			min-height="32"
			:active="false"
			:value="element.name"
		>
			<template v-slot:title>
				<div class="d-flex align-center">
					<ao-icon
						:class="[
							isOpen ? 'text-primary' : 'ao-text-secondary-color-700',
							'mr-2',
						]"
						:iconName="isOpen ? 'folderOn' : 'folderOff'"
					/>
					<span class="text-caption">{{ element.name }}</span>
				</div>
			</template>
			<template v-slot:append>
				<v-menu
					v-model="isActiveMenu"
				>
					<template v-slot:activator="{ props }">
						<ao-icon-btn
							v-bind="props"
							size="20"
							variant="plain"
							color="primary"
							iconName="dotsHorizontal"
							class="menu-icon"
						/>
					</template>
					<v-list
						class="px-2"
					>
						<v-menu
							v-model="isActiveGroupForm"
							location="right"
							:close-on-content-click="false"
						>
							<template v-slot:activator="{ props }">
								<ao-btn
									v-bind="props"
									prependIconName="pen"
									custom="favoriteSettingMenuItem"
								>
									{{ $t('Rename') }}
								</ao-btn>
							</template>
							<FavoriteGroupForm
								:currentState="element"
								@saveGroup="($event) => {
									$emit('update', {
										...element,
										name: $event.name,
									})
									isActiveMenu = false
								}"
								@cancel="isActiveGroupForm = false"
							/>
						</v-menu>
						<ao-btn
							prependIconName="delete"
							custom="favoriteSettingMenuItem"
							@click="$emit('delete', element)"
						>
							{{ $t('Delete') }}
						</ao-btn>
					</v-list>
				</v-menu>
			</template>
		</v-list-item>
	</div>
</template>

<script setup>
import { ref } from 'vue'
import FavoriteGroupForm from '@/components/favorites/FavoriteGroupForm.vue'

defineProps({
	listGroupProps: {
		type: Object,
		required: true,
	},

	isOpen: {
		type: Boolean,
		required: true,
	},

	element: {
		type: Object,
		required: true,
	},
})

defineEmits({
	update: null,
	delete: null,
})

const isActiveMenu = ref(false)
const isActiveGroupForm = ref(false)
</script>

<style lang="scss">
.app-favorite-group-item {
	position: relative;

	.draggable-handler {
		position: absolute;
		top: 50%;
		opacity: 0;
		transform: translateY(-50%);
		transition: opacity 0.3s ease-in-out;
	}

	.menu-icon {
		opacity: 0;
		transition: opacity 0.3s ease-in-out;
	}

	&:hover {
		.draggable-handler {
			opacity: 1;
		}

		.menu-icon {
			opacity: 1;
		}
	}
}
</style>
